module.exports = __webpack_public_path__ + "img/logo_salhus.fea52a80.png";